import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface HSDocumentItem {
  id: string;
  last_read_at?: string;
  [key: string]: any;
}

interface HSDocumentsState {
  items: HSDocumentItem[];
  loading: boolean;
  error: string | null;
}

const initialState: HSDocumentsState = {
  items: [],
  loading: false,
  error: null,
};

const hsDocumentsSlice = createSlice({
  name: 'hsDocuments',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    getHSDocuments: (state) => {
      console.log("getHSDocuments");
      state.loading = true;
      state.error = null;
    },
    getHSDocumentsCommit: (state, action: PayloadAction<{
      documents?: HSDocumentItem[];
      page?: number;
    }>) => {
      state.loading = false;
      if (action.payload.page) {
        if (action.payload.documents && action.payload.documents.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.documents);
        }
      } else {
        state.items = action.payload.documents || [];
      }
    },
    getHSDocumentsFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateDocReadAt: (state, action: PayloadAction<{
      id: string;
      last_read_at: string;
    }>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = {
          ...state.items[index],
          last_read_at: action.payload.last_read_at
        };
      }
    },
    updateDocReadAtCommit: (state) => {
      // Handle success if needed
    },
    updateDocReadAtFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const {
  getHSDocuments,
  getHSDocumentsCommit,
  getHSDocumentsFailed,
  updateDocReadAt,
  updateDocReadAtCommit,
  updateDocReadAtFailed,
} = hsDocumentsSlice.actions;

export default hsDocumentsSlice.reducer;